import { Heading } from "@ariakit/react";
import { SyncLog } from "@indietabletop/appkit";
import { section } from "./style.css.ts";

export function SyncLogSection() {
  return (
    <section className={section.container({ jagged: 2 })}>
      <Heading className={section.heading}>Sync Log</Heading>

      <SyncLog />
    </section>
  );
}
